export class WorkFlowQueueParametersDto {
    includeAll: boolean; // Set to false (default) to return only My Work Inbox. Set to true to return All Work Inbox
    clearCache = false;
    status: string;
    liteMode = true;
    managementCompanyId: number;
    communityId: number;
    locationId: number;

    getQueryString(): string {
        const tokens = [];
        if (!!this.managementCompanyId) {
            tokens.push(`managementCompanyId=${this.managementCompanyId}`);
        }
        if (!!this.communityId) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (!!this.locationId) {
            tokens.push(`locationId=${this.locationId}`);
        }
        if (!!this.status) {
            tokens.push(`&status=${this.status}`);
        }
        tokens.push(`includeAll=${this.includeAll}`, `clearCache=${this.clearCache}`, `liteMode=${this.liteMode}`);
        return `?${tokens.join('&')}`;
    }
}
